import { ProductsApi, useAPIQuery } from "melco-shared-logic";

export const useLevelSubscriptionDropDownData = (
  selectedProductValue: string,
  selectedVersionValue: string
) => {
  //const baseApiConfig = useBaseAPIConfig();

  return useAPIQuery(
    ProductsApi,
    ["levelSubscriptionDropDownData"],
    async (api) => {
      //const api = new ProductsApi(baseApiConfig({ token }));

      if (selectedProductValue) {
        const response = await api.productsGetModuleList({
          productCodeList: selectedProductValue,
          versionNumberList: selectedVersionValue,
        });

        return response;
      }
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );
};
